import React from 'react';
import { Cell, formatAction } from '../PartnerAuditLogs.utils';
export const getPartnerAuditLogsBody = partnerAuditLogs => {
  if (!partnerAuditLogs) return [];
  return partnerAuditLogs.data.map(row => {
    const time = row.attributes.time;
    const actor = row.attributes.actor.name;
    const action = row.attributes.action;
    return {
      key: time + actor + action,
      cells: [{
        key: 'time',
        content: /*#__PURE__*/React.createElement(Cell, null, new Date(time).toLocaleString())
      }, {
        key: 'name',
        content: /*#__PURE__*/React.createElement(Cell, null, actor)
      }, {
        key: 'action',
        content: /*#__PURE__*/React.createElement(Cell, null, formatAction(action))
      }]
    };
  });
};
export const getPartnerAuditLogsHead = () => {
  return {
    key: 'appKey',
    cells: [{
      key: 'time',
      content: 'Time',
      isSortable: false
    }, {
      key: 'name',
      content: 'Name',
      isSortable: false
    }, {
      key: 'action',
      content: 'Action',
      isSortable: false
    }]
  };
};